import React from 'react';
import { Link } from 'react-router';
import MenuItem from 'material-ui/MenuItem';
import PropTypes from 'prop-types';

import EditableCategorizedItemList from './EditableCategorizedItemList';

class QuestionList extends React.Component {

  constructor(props) {
    super(props);
    this.onItemClick = this.onItemClick.bind(this);
  }

  render() {
    let props = this.props;
    return (
      <div>
        <EditableCategorizedItemList
          categories={props.categories}
          items={props.questions}
          deleteCategoryAction={props.deleteCategory}
          onItemClick={this.onItemClick}
          showCategoryDescription={false}
          fabItems={[
            <MenuItem key="mi1" primaryText="New Category" containerElement={<Link to="/admin/categories/create/question" />} />,
            <MenuItem key="mi2" primaryText="New Question" containerElement={<Link to="/admin/questions/create" />} />
          ]}
          editable={!props.isTranslation}
          translation={props.translation}
        />
      </div>
    )
  }

  onItemClick(id) {
    if(this.props.isTranslation){
      this.props.router.push("/admin/translation/" + parseInt(this.props.params.trID) + "/questions/" + id);
    } else {
      this.props.router.push("/admin/questions/" + id);
    }
  }
}

QuestionList.propTypes = {
  questions: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  deleteCategory: PropTypes.func.isRequired
}

export default QuestionList;
